/**
 * The transportation mode for the route.
 */
export enum TravelMode {
  /**  default mode, same as car  */
  AUTO = 'auto',
  /**  car mode  */
  CAR = 'car',
  /**  truck mode  */
  TRUCK = 'truck',
}

/**
 * Output format of the route geometry.
 */
export enum GeometryType {
  /**  Polyline format geometry.  */
  POLYLINE = 'polyline',
  /**  Polyline6 format geometry.  */
  POLYLINE_6 = 'polyline6',
  /**  Geojson format geometry.  */
  GEOJSON = 'geojson',
}

export enum AvoidType {
  /**  Avoid toll in route.  */
  TOLL = 'toll',
  /**  Avoid ferry in route.  */
  FERRY = 'ferry',
  /**  Avoid highway in route.  */
  HIGHWAY = 'highway',
}

export enum OverviewType {
  /**  Include full info in oveview  */
  FULL = 'full',
  /**  Only inlude simplified info in overview  */
  SIMPLIFIED = 'simplified',
  /**  Not include overview in result */
  FALSE = 'false',
}

export enum ApproachType {
  /**  route can arrive at the waypoint from either side of the road  */
  UNRESTRICTED = 'unrestricted',
  /** route will arrive at the waypoint on the driving_side of the region  */
  CURB = 'curb',
}
